<script>
  import lodash from 'lodash';
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'ByPersonTrendChart',
    extends: TrendChart,
    data() {
      return {
        chartId: 'hearingTestTrends',
        propertyName: 'number_audiograms',
        propertyNamePerson: '',
        label: 'Audiograms',
      };
    },
    computed: {
      propertyNamePhys() {
        return `${this.propertyNamePerson}_by_physician`;
      },
      propertyNameAud() {
        return `${this.propertyNamePerson}_by_audiologist`;
      },
      benchmark() {
        return {
          kpi_name: this.propertyName,
          low_value_monthly: (this.numPerPerson.low_value_monthly || 0) * this.avgNumPersons,
          median_value_monthly: (this.numPerPerson.median_value_monthly || 0) * this.avgNumPersons,
          high_value_monthly: (this.numPerPerson.high_value_monthly || 0) * this.avgNumPersons,
        };
      },
      numPerPhys() {
        return lodash.find(this.benchmarks, ['kpi_name', this.propertyNamePhys]);
      },
      isEnt() {
        return this.numPerPhys !== undefined;
      },
      numPerPerson() {
        return this.isEnt ? this.numPerPhys : lodash.find(this.benchmarks, ['kpi_name', this.propertyNameAud]);
      },
      numPersonsField() {
        return this.isEnt ? 'number_physicians' : 'number_providers';
      },
      avgNumPersons() {
        return lodash.reduce(this.curYear, (sum, value) => sum + parseFloat(value[this.numPersonsField]), 0)/this.curYear.length;
      },
    },
  };
</script>
